'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormInput = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(FormInput, _React$PureComponent);

    function FormInput() {
        (0, _classCallCheck3.default)(this, FormInput);
        return (0, _possibleConstructorReturn3.default)(this, (FormInput.__proto__ || (0, _getPrototypeOf2.default)(FormInput)).apply(this, arguments));
    }

    (0, _createClass3.default)(FormInput, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                name = _props.name,
                value = _props.value,
                label = _props.label,
                isRequired = _props.isRequired,
                maxLength = _props.maxLength,
                className = _props.className,
                inputClassName = _props.inputClassName,
                icon = _props.icon,
                error = _props.error,
                onChange = _props.onChange,
                prefix = _props.prefix,
                rest = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'label', 'isRequired', 'maxLength', 'className', 'inputClassName', 'icon', 'error', 'onChange', 'prefix']);

            var htmlId = this.getFieldId();
            var divClass = 'form__input';
            if (isRequired) {
                divClass += ' form__input--required';
            }
            if (className) {
                divClass += ' ' + className;
            }
            var inputClass = (inputClassName || '') + ' input input--init';
            if (value) {
                inputClass += ' input--filled';
            }

            if (error) {
                inputClass += ' input-validation-error';
            }

            var autoCompleteObject = this.props.autoComplete ? { autoComplete: "off" } : {};

            return _react2.default.createElement(
                'div',
                { className: divClass },
                _react2.default.createElement('input', (0, _extends3.default)({ id: htmlId, name: htmlId, className: inputClass, value: value || '', maxLength: maxLength,
                    onInput: onChange }, rest, { type: 'text' }, autoCompleteObject)),
                _react2.default.createElement(
                    'label',
                    { htmlFor: htmlId },
                    !!icon && _react2.default.createElement('i', { className: icon }),
                    ' ',
                    label
                ),
                !!error && _react2.default.createElement(
                    'span',
                    { className: 'field-validation-error' },
                    error
                )
            );
        }
    }, {
        key: 'getFieldId',
        value: function getFieldId() {
            return (this.props.prefix || '') + this.props.name;
        }
    }]);
    return FormInput;
}(_react2.default.PureComponent), _class.propTypes = {
    name: _propTypes2.default.string.isRequired,
    value: _propTypes2.default.any,
    label: _propTypes2.default.string.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    isRequired: _propTypes2.default.bool,
    maxLength: _propTypes2.default.number,
    className: _propTypes2.default.string,
    inputClassName: _propTypes2.default.string,
    error: _propTypes2.default.string,
    icon: _propTypes2.default.string,
    prefix: _propTypes2.default.string,
    type: _propTypes2.default.string,
    autoComplete: _propTypes2.default.bool
}, _temp);
exports.default = FormInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/FormInput.js
// module id = 197
// module chunks = 0 2